import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type BranchTableToolbarProps = {
  numSelected: number;
  filterName: string;
  onFilterName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch?: () => void;
  onExport?: () => void;
  // Company filter props
  filterCompany?: string;
  onFilterCompany?: (company: string) => void;
  companyOptions?: string[];
};

export function BranchTableToolbar({ 
  numSelected, 
  filterName, 
  onFilterName, 
  onClearSearch, 
  onExport,
  filterCompany = '',
  onFilterCompany,
  companyOptions = [],
}: BranchTableToolbarProps) {
  
  const handleCompanyChange = (event: SelectChangeEvent<string>) => {
    if (onFilterCompany) {
      onFilterCompany(event.target.value);
    }
  };

  const hasActiveFilters = filterName || filterCompany;

  return (
    <Toolbar
      sx={{
        height: 96,
        display: 'flex',
        justifyContent: 'space-between',
        p: (theme) => theme.spacing(0, 1, 0, 3),
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <OutlinedInput
            value={filterName}
            onChange={onFilterName}
            placeholder="Şube ara... (Gerçek zamanlı filtreleme)"
            startAdornment={
              <InputAdornment position="start">
                <Iconify width={20} icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
            sx={{ maxWidth: 320 }}
          />
          
          {companyOptions.length > 0 && onFilterCompany && (
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Şirket Filtrele</InputLabel>
              <Select
                value={filterCompany}
                label="Şirket Filtrele"
                onChange={handleCompanyChange}
              >
                <MenuItem value="">
                  <em>Tümü</em>
                </MenuItem>
                {companyOptions.map((company) => (
                  <MenuItem key={company} value={company}>
                    {company}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          
          {hasActiveFilters && onClearSearch && (
            <IconButton
              onClick={onClearSearch}
              sx={{ 
                bgcolor: 'error.main', 
                color: 'white',
                '&:hover': { bgcolor: 'error.dark' }
              }}
            >
              <Iconify icon="eva:close-fill" />
            </IconButton>
          )}
        </Box>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Sil">
          <IconButton>
            <Iconify icon="solar:trash-bin-trash-bold" />
          </IconButton>
        </Tooltip>
      ) : (
        <Stack direction="row" spacing={1}>
          {onExport && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<Iconify icon="eva:download-outline" />}
              onClick={onExport}
            >
              Dışa Aktar
            </Button>
          )}
          <Tooltip title="Listeyi filtrele">
            <IconButton>
              <Iconify icon="ic:round-filter-list" />
            </IconButton>
          </Tooltip>
        </Stack>
      )}
    </Toolbar>
  );
}
